export default __webpack_public_path__ + "static/media/illustrated-background-mobile.51d74ada.svg";